import { isImageFile } from '../../../utils/file'

export function getPreparedDocuments(files) {
  return files.reduce(
    (acc, file) => {
      if (isImageFile(file)) {
        acc.images.push(file)
      } else {
        acc.documents.push(file)
      }

      return acc
    },
    { documents: [], images: [] }
  )
}
